<template>
    <div>
        <failure-snackbar v-model="showErrorPaymentMethod">Fehler beim Eintragen.</failure-snackbar>
        <success-snackbar v-model="showSuccess">Erfolfgreich eingetragen.</success-snackbar>
        <v-dialog v-model="dialog" max-width="1024px">
            <template v-slot:activator="{ on }">
                <v-btn color="secondary"
                       v-on="on">Auf warteliste eintragen
                </v-btn>
            </template>
            <v-card>
                <v-card-title primary-title class="title">
                    Auf Warteliste eintragen?
                </v-card-title>
                <v-card-text>
                    Wir benachrichtigen Sie per E-Mail sobald ein Platz frei wird. Nach dem Eintragen auf die Warteliste
                    erhalten Sie eine Bestätigung ihrer EIntragung per E-Mail.
                    <v-form ref="queueForm">
                        <v-container grid-list-xl>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <s-email-field
                                            v-model="email"
                                            label="E-Mail"
                                            :rules="rules.email"></s-email-field>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <s-select
                                            v-model="salutation"
                                            label="Anrede"
                                            :items="['Herr', 'Frau']"
                                            :rules="rules.salutation">
                                    </s-select>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <s-select
                                            v-model="title"
                                            label="Titel (optional)"
                                            :items="['Dr.', 'Prof.', 'Prof. Dr.', 'PD', 'PD Dr.']">
                                    </s-select>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <s-text-field
                                            v-model="first_name"
                                            label="Vorname"
                                            :rules="rules.first_name"></s-text-field>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <s-text-field
                                            v-model="last_name"
                                            label="Nachname"
                                            :rules="rules.last_name"></s-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <s-text-field
                                            v-model="phone"
                                            label="Telefon (optional)"
                                            :rules="rules.phone"></s-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-divider v-if="!loading"></v-divider>
                <v-progress-linear class="ma-0" :indeterminate="true" v-show="loading" height="1"></v-progress-linear>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="dialog=false" :disabled="loading">{{__('general.cancel')}}</v-btn>
                    <v-btn flat color="primary" @click="send()" :disabled="loading">{{__('general.send')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: "QueueDialog",
        props: {
            ticketId: Number
        },
        data() {
            return {
                email: '',
                salutation: '',
                title: '',
                first_name: '',
                last_name: '',
                phone: '',
                loading: false,
                dialog: false,
                showErrorPaymentMethod: false,
                showSuccess: false,
                rules: this.$validation.create({
                        email: ['required', 'email', 'maxLen:255'],
                        salutation: ['required'],
                        title: [],
                        first_name: ['required', 'maxLen:255'],
                        last_name: ['required', 'maxLen:255'],
                        phone: ['maxLen:255'],
                    }
                )
            }
        },
        methods: {
            send: function () {
                if (this.$refs.queueForm.validate()) {
                    this.loading = true;
                    axios.post("/checkout/waiting_list/store", {
                        email: this.email,
                        salutation: this.salutation,
                        title: this.title,
                        first_name: this.first_name,
                        last_name: this.last_name,
                        phone: this.phone,
                        ticket_id: this.ticketId
                    }).then(response => {
                        this.loading = false;
                        this.dialog = false;
                        this.showSuccess = true;
                    }).catch(error => {
                        this.loading = false;
                        this.showErrorPaymentMethod = true;
                    });
                }
            },
        }
    }
</script>

<style scoped>

</style>
